import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.handleShowTakeaways = this.handleShowTakeaways.bind(this)
    window.addEventListener('lesson-interstitial:showTakeaways', this.handleShowTakeaways)
  }

  disconnect() {
    window.removeEventListener('lesson-interstitial:showTakeaways', this.handleShowTakeaways)
  }

  handleShowTakeaways() {
    this.show()
  }

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  hide() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }
}
